// extracted by css-extract-rspack-plugin
module.exports =  {"card":"GroupCard-DNMk__card","header":"GroupCard-SsHX__header","no-image":"GroupCard-Quaz__no-image","list":"GroupCard-Na7E__list"};